<script setup lang="ts">
import type { Organization } from '@/stores/admin'
import { useAdmin } from '@/stores/admin'
import { ref } from 'vue'
import { useRoute } from 'vue-router'
import AdminOrganizationUsers from '@/views/forms/AdminOrganizationUsers.vue'
import { getStytchOrganizationUrl } from '@/lib/stytch'

const route = useRoute()
const admin = useAdmin()

if (admin.organizations.length === 0) {
  await admin.fetchOrganizations()
}

const organization = ref<Organization | undefined>(
  admin.organizations.find((org: Organization) => org.slug === (route.params.slug as string)),
)
</script>

<template>
  <AppComponent
    id="admin-organization-users"
    :title="organization ? `Users: ${organization?.name}` : 'Users'"
  >
    <div class="flex flex-col gap-2 sm:gap-4 lg:gap-4 w-full lg:max-w-2xl mx-auto">
      <UPageCard
        title="Users"
        description="Manage users who have access to this organization."
        variant="naked"
        orientation="horizontal"
        class="mb-4"
      >
        <UButton
          :to="getStytchOrganizationUrl(organization?.stytch_organization_id)"
          target="_blank"
          icon="i-lucide-external-link"
          variant="outline"
          color="neutral"
          class="w-fit lg:ms-auto"
          v-if="organization?.stytch_organization_id"
        >
          Manage in Stytch
        </UButton>
      </UPageCard>
      <UPageCard variant="subtle">
        <AdminOrganizationUsers v-if="organization" :organization="organization" />
      </UPageCard>
    </div>
  </AppComponent>
</template>
